import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import eventBus from '@/config/eventBus';
import { setBaseUrl, setInterceptors } from '@/config/axios';
import "./assets/fonts/DINRoundPro.css";
import config from 'devextreme/core/config';
import 'devextreme/dist/css/dx.fluent.saas.dark.css';
import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import './assets/css/dx.override.style.css';
import dxTextBox from 'devextreme/ui/text_box';
import dxDateBox from 'devextreme/ui/date_box';
import dxNumberBox from 'devextreme/ui/number_box';
import dxSelectBox from 'devextreme/ui/select_box';
import dxTagBox from 'devextreme/ui/tag_box';
import dxLookup from 'devextreme/ui/lookup';
import dxAutocomplete from 'devextreme/ui/autocomplete';
import dxTextArea from 'devextreme/ui/text_area';
import dxDropDownBox from 'devextreme/ui/drop_down_box';
import dxColorBox from 'devextreme/ui/color_box';
import dxHtmlEditor from 'devextreme/ui/html_editor';
import VueImageZoomer from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';

config({
    licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjVjZjgwNGYzLWVhYzAtNDI0NS1iYzY0LTU1ODFhMzY1NjU2ZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.fb8ZYB/J+uUIdUJiiKh7auAxtPFw5Xs+0KpNAd8FGcPpcT+K50tWGB/Km0m8c++C3T5qkARIRz4el664iIaQz8i9HqzXC6eaz5sQUjutOM1MZ29TzN/Oy55RORBaW2CYJbpkLA==',
    editorStylingMode: 'outlined', // filled or 'outlined' | 'underlined'
});

const defaultOptions = {
    options: {
        height: "45px",
        labelMode: 'floating'
    },
};
dxTextBox.defaultOptions(defaultOptions);
dxDateBox.defaultOptions(defaultOptions);
dxNumberBox.defaultOptions(defaultOptions);
dxSelectBox.defaultOptions(defaultOptions);
dxTagBox.defaultOptions(defaultOptions);
dxLookup.defaultOptions(defaultOptions);
dxAutocomplete.defaultOptions(defaultOptions);
dxTextArea.defaultOptions(defaultOptions);
dxDropDownBox.defaultOptions(defaultOptions);
dxColorBox.defaultOptions(defaultOptions);
dxHtmlEditor.defaultOptions(defaultOptions);

loadMessages(esMessages);
locale('es-PY');

const app = createApp(App);

app.config.globalProperties.$eventBus = eventBus;

setBaseUrl();
setInterceptors();

app.use(store)
    .use(router)
    .use(vuetify)
    .use(VueImageZoomer)
    .mount('#app');
